import { ThemeProvider, EmotionCacheProvider } from '@ori-ui/mui';
import { UniversalTokenProvider, doDevelopmentLogin } from '@ori/auth';
import { parseClientAppConfig } from '@ori/client-app-config';
import { ApplicationInsights, ErrorBoundary, getClientApplicationInsightsConfig } from '@ori/logger';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import { EMOTION_CACHE_KEY } from './constants-generated';
import { mainLogger } from './logger';
import { jsx as _jsx } from "react/jsx-runtime";
const localLogger = mainLogger.createChild('appRender');

/**
 * React app renderer that is used when app is used as a standalone app
 */
export const render = async rootElement => {
  const {
    config = ''
  } = rootElement.dataset;
  const {
    customerId,
    identityUrl,
    ...appConfig
  } = parseClientAppConfig(config, ['tenant', 'staticApiUrl']);
  const {
    tenant
  } = appConfig;

  // Initialize Application Insights in production
  if (process.env.NODE_ENV === 'production') {
    ApplicationInsights.initialize(getClientApplicationInsightsConfig());
  }
  // When using Requestly we do not want to load token
  else if (process.env.REACT_APP_USE_REQUESTLY === '1') {
    localLogger.debug('USING REQUESTLY');
  }
  // Get token for local development
  else if (process.env.REACT_APP_ANONYMOUS_MODE !== '1') {
    if (identityUrl) {
      await doDevelopmentLogin({
        identityUrl,
        tenant
      });
    } else {
      localLogger.error(new Error('Missing Identity URL!', {
        cause: identityUrl
      }));
    }
  }
  createRoot(rootElement).render(/*#__PURE__*/_jsx(ErrorBoundary, {
    logger: localLogger,
    children: /*#__PURE__*/_jsx(UniversalTokenProvider, {
      customerId: customerId,
      initialToken: "",
      children: /*#__PURE__*/_jsx(EmotionCacheProvider, {
        cacheKey: EMOTION_CACHE_KEY,
        children: /*#__PURE__*/_jsx(ThemeProvider, {
          children: /*#__PURE__*/_jsx(App, {
            ...appConfig
          })
        })
      })
    })
  }));
  return true;
};